import Vue from "vue"
import moment from "@/moment-gp";
import util from '@/util';

Vue.filter("first4Chars", str => str.substring(0, 4))

Vue.filter("last4Chars", str => str.substring(str.length - 4))

Vue.filter("defaultUserPic", url => {
  if ( !url || url === '' ) {
    return 'https://d2c3nvafyekx5z.cloudfront.net/images/generic-avatar/avatar-e0e3e9b53e910c67048daed098204162.svg';
  }
  return url;
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString().toLowerCase();
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter("calendarDateFromFirebase", date => {
  // TODO: Remove!
  /* "Today at 1:21 AM" */
  if (date) {
    return moment(date.seconds * 1000).calendar();
  } else {
    return "undefined date";
  }
})

Vue.filter("dateTimeFromFirebase", date => {
  // TODO: Remove!
  /* wird nur 1x genutzt! */
  return moment(date.seconds * 1000).format("DD-MM-YYYY hh:mm:ss");
})

/* Vue.filter("fromNow", date => {
  // TODO: moved to locale-fitlers.js
  if (date) {
    return moment(date).fromNow();
  } else {
    return "unknown";
  }
}) */

Vue.filter("formatSeconds", (time_in_seconds) => {
  // TODO: move to locale-fitlers.js
  return util.showHoursMinutesSeconds(time_in_seconds * 1000);
});

Vue.filter("percentageColor", finishedPercent => {
  let color = "#f28d00";
  if (finishedPercent === 100) {
    color = "#009f3c";
  } else if (finishedPercent === 0) {
    color = "#e30613";
  } else if (finishedPercent < 15) {
    color = "#ed6b06";
  } else if (finishedPercent < 30) {
    color = "#ed6b06";
  } else if (finishedPercent < 40) {
    color = "#f28d00";
  } else if (finishedPercent < 50) {
    color = "#8fbf21";
  } else if (finishedPercent < 100) {
    color = "#34a936";
  }
  return color;
})
